import React from 'react';
import { User } from '@tcc/shared-data-lib';
import { EnableMFADialog } from '@tcc/plugin-ui';
import { useMFADialog } from '../../hooks/useMFADialog';

interface MFADialogProps {
  user: User;
  featureFlags: Record<string, boolean>;
}

export const MFADialog = ({
  user,
  featureFlags,
}: MFADialogProps) => {
  const { handleMFACancel, showMFADialog, setShowMFADialog, onEnableMFA, isEnabling } = useMFADialog({
    user,
    featureFlags
  });

  if (!showMFADialog) {
    return null;
  }

  return (
    <EnableMFADialog
      open={showMFADialog}
      setOpen={setShowMFADialog}
      onCancel={handleMFACancel}
      onEnable2FA={onEnableMFA}
      isEnabling={isEnabling}
    />
  );
};